import { ref } from 'vue';
import { themeQuartz, iconSetQuartzBold } from 'ag-grid-community';

export const BlackAgGridDark = themeQuartz.withParams({
    accentColor               : "#00CCFF",
    backgroundColor           : "#000000",
    borderColor               : "#FFFFFFED",
    borderRadius              : 3,
    browserColorScheme        : "inherit",
    cellHorizontalPaddingScale: 1,
    chromeBackgroundColor     : { ref: "backgroundColor" },
    columnBorder              : false,
    fontSize                  : 16,
    foregroundColor           : "#FAFAFA",
    headerBackgroundColor     : "#000000",
    headerFontWeight          : 600,
    headerTextColor           : "#FFFFFF",
    headerVerticalPaddingScale: 1,
    iconSize                  : 20,
    oddRowBackgroundColor     : "#1A1A1A",
    rowBorder                 : false,
    rowVerticalPaddingScale   : 1,
    sidePanelBorder           : true,
    spacing                   : 5,
    wrapperBorder             : false,
    wrapperBorderRadius       : 0
});

export const LightAgGridDark = themeQuartz.withParams({
    backgroundColor      : "#1f2836",
    borderColor          : "#374151",
    browserColorScheme   : "dark",
    chromeBackgroundColor: { ref : "foregroundColor", mix : 0.07, onto: "backgroundColor"},
    fontSize             : 20,
    columnBorder         : false,
    foregroundColor      : "#FFFFFF",
    headerRowBorder      : true,
    rowBorder            : true
});

export const DarkAgGrid = themeQuartz.withParams({
    accentColor               : "#00CCFF",
    backgroundColor           : "#0C0C0D",
    borderColor               : "#FFFFFF00",
    borderRadius              : 3,
    browserColorScheme        : "inherit",
    cellHorizontalPaddingScale: 1,
    chromeBackgroundColor     : { ref: "backgroundColor" },
    columnBorder              : false,
    fontSize                  : 16,
    foregroundColor           : "#FAFAFA",
    headerBackgroundColor     : "#182226",
    headerFontWeight          : 500,
    headerTextColor           : "#FFFFFF",
    headerVerticalPaddingScale: 0.9,
    iconSize                  : 20,
    oddRowBackgroundColor     : "#1A1A1A",
    rowBorder                 : true,
    rowVerticalPaddingScale   : 1.2,
    sidePanelBorder           : true,
    spacing                   : 5,
    wrapperBorder             : true,
    wrapperBorderRadius       : 0
});

// to use myTheme in an application, pass it to the theme grid option
export const LightAgGrid = themeQuartz.withPart(iconSetQuartzBold).withParams({
        accentColor               : "#4E06B9",
        backgroundColor           : "#FFFFFF",
        borderColor               : "#000000",
        borderRadius              : 4,
        browserColorScheme        : "light",
        cellHorizontalPaddingScale: 0.7,
        columnBorder              : false,
        fontFamily                : { googleFont: "Tahoma" },
        fontSize                  : 13,
        foregroundColor           : "#555B62",
        headerBackgroundColor     : "#DADADA",
        headerFontFamily          : { googleFont: "Tahoma" },
        headerFontSize            : 13,
        headerFontWeight          : 900,
        headerTextColor           : "#19191A",
        oddRowBackgroundColor     : "#A8A8A826",
        rowBorder                 : false,
        rowVerticalPaddingScale   : 1.2,
        sidePanelBorder           : true,
        spacing                   : 6,
        wrapperBorder             : false,
        wrapperBorderRadius       : 4
    });


// Setup pagination for AgGrid
export const paginationPageSize         = ref(10);
export const paginationPageSizeSelector = ref([10, 20, 50, 100, 250, 500]);
// export const rowData                    = ref([]);
// export const columnDefs                 = ref([]);

// Central Default Column Definition
export const defaultColDef = {
    flex     : 1,
    minWidth : 100,
    resizable: true
};